import { render, staticRenderFns } from "./MsgPopup.vue?vue&type=template&id=9947c0c8&"
import script from "./MsgPopup.vue?vue&type=script&lang=js&"
export * from "./MsgPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports